"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 12.5 3.5';

var Ellipsis = function Ellipsis() {
  return _react["default"].createElement("path", {
    d: "M1.95,0.5 C1.1525,0.5 0.5,1.1525 0.5,1.9495 C0.5,2.747 1.1525,3.4 1.95,3.4 C2.7475,3.4 3.3995,2.747 3.3995,1.9495 C3.3995,1.1525 2.7475,0.5 1.95,0.5 Z M10.6485,0.5 C9.8515,0.5 9.199,1.1525 9.199,1.9495 C9.199,2.747 9.8515,3.4 10.6485,3.4 C11.446,3.4 12.0985,2.747 12.0985,1.9495 C12.0985,1.1525 11.446,0.5 10.6485,0.5 Z M6.299,0.5 C7.097,0.5 7.7495,1.1525 7.7495,1.9495 C7.7495,2.747 7.097,3.4 6.299,3.4 C5.502,3.4 4.8495,2.747 4.8495,1.9495 C4.8495,1.1525 5.502,0.5 6.299,0.5 Z"
  });
};

var _default = (0, _createSvgIcon["default"])(Ellipsis, {
  viewBox: viewBox
});

exports["default"] = _default;